import React from 'react';
import { MessageCircle, ThumbsUp, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Question } from '../../types/qa';

interface QuestionCardProps {
  question: Question;
  onVote: (id: string) => void;
}

export function QuestionCard({ question }: QuestionCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/#waitlist');
  };

  const timeAgo = (date: string) => {
    const seconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);
    
    let interval = seconds / 31536000;
    if (interval > 1) return Math.floor(interval) + ' years ago';
    
    interval = seconds / 2592000;
    if (interval > 1) return Math.floor(interval) + ' months ago';
    
    interval = seconds / 86400;
    if (interval > 1) return Math.floor(interval) + ' days ago';
    
    interval = seconds / 3600;
    if (interval > 1) return Math.floor(interval) + ' hours ago';
    
    interval = seconds / 60;
    if (interval > 1) return Math.floor(interval) + ' minutes ago';
    
    return Math.floor(seconds) + ' seconds ago';
  };

  return (
    <div 
      onClick={handleClick}
      className="group bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6 hover:shadow-md transition-all cursor-pointer"
    >
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2 group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors">
        {question.title}
      </h3>
      <p className="text-gray-600 dark:text-gray-300 mb-4 line-clamp-2">
        {question.content}
      </p>
      <div className="flex items-center justify-between text-sm">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1 text-gray-500 dark:text-gray-400">
            <ThumbsUp className="w-4 h-4" />
            <span>{question.votes}</span>
          </div>
          <div className="flex items-center gap-1 text-gray-500 dark:text-gray-400">
            <MessageCircle className="w-4 h-4" />
            <span>4 answers</span>
          </div>
        </div>
        <div className="flex items-center gap-1 text-gray-500 dark:text-gray-400">
          <Clock className="w-4 h-4" />
          <span>{timeAgo(question.createdAt)}</span>
        </div>
      </div>
    </div>
  );
}